module.exports = __webpack_public_path__ + "img/register-bg.d218fc96.png";